export const DELETE = 'delete' as const;
export const UPDATE = 'update' as const;
export const CREATE = 'create' as const;
